import React from 'react';
import { EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, PanelBody, PanelHeader, Tray } from '../../../components/elements';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { getOpenApiRouteItemUrlValidatingElements } from '../../../components/validatingComponents/getOpenApiRouteItemUrlValidatingElements';
import { ValidatingEditPanelSaveButton } from '../../../components/validatingElements';
import { useTranslate } from '../../../mixins/translate/translate';
import { labelSelectOptions } from '../common/labelSelectOptions';

const validatingElements = getOpenApiRouteItemUrlValidatingElements('/api/surveys/{surveyId}/inspectionStandardData/rovLabel', 'post');

export function SurveyEditRovLabelResult(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    const translate = useTranslate();

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <PanelBody isForm={true}>
                    <validatingElements.ItemUrlForm
                        onSubmitted={props.onItemChanged}
                        routeParams={{
                            surveyId: props.surveyId,
                        }}
                    >
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.InputText name="naam" topLabel="Naam" />
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.InputText name="locatie" topLabel="Locatie" />
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={12}>
                                <validatingElements.TextArea name="omschrijving" topLabel="Omschrijving" />
                            </EditPanelCell>
                        </EditPanelRow>

                        <PanelHeader text="Score" fixWidth={true} />

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>
                                <strong>{translate('inspectionLabel.scubaInspection')}</strong>
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>
                                <strong>{translate('inspectionLabel.rovInspection')}</strong>
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.cost')}</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.cost')}</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieKostenRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieKosten" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieKostenRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="rovInspectieKosten" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore voor de inspecteur</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore voor de inspecteur</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van de (vaar) weggebruiker</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van de (vaar) weggebruiker</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het object</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Veiligheidsrisicoscore van het object</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore" />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.InputNumber name="rovInspectieVeiligheidsrisicoscoreVanHetObjectScore" />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>De hinder voor het wegverkeer (Klasse, Categorie)</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>De hinder voor het wegverkeer (Klasse, Categorie)</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerKlasse"
                                    selectOptions={labelSelectOptions.hinderKlasse}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieDeHinderVoorHetWegverkeerRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieDeHinderVoorHetWegverkeerKlasse"
                                    selectOptions={labelSelectOptions.hinderKlasse}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieDeHinderVoorHetWegverkeerCategorie"
                                    selectOptions={labelSelectOptions.hinderCategorie}
                                />{' '}
                            </EditPanelCell>
                            <EditPanelCell rowCount={4}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={2}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieDeHinderVoorHetWegverkeerCategorie"
                                    selectOptions={labelSelectOptions.hinderCategorie}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.environment')}</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.environment')}</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieMilieuRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieMilieuRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.efficiency')}</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>{translate('inspectionLabel.efficiency')}</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieRendementRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieRendementRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={5}>Overall score</EditPanelCell>
                            <EditPanelCell rowCount={1}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={5}>Overall score</EditPanelCell>
                        </EditPanelRow>
                        <EditPanelRow fixWidth>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="reguliereInspectieOverallRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={3}>&nbsp;</EditPanelCell>
                            <EditPanelCell rowCount={3}>
                                {' '}
                                <validatingElements.FilterDropdown
                                    name="rovInspectieOverallRovLabelScore"
                                    selectOptions={labelSelectOptions.labelScore}
                                />{' '}
                            </EditPanelCell>
                        </EditPanelRow>

                        <EditPanelButtons>
                            <ValidatingEditPanelSaveButton small={true} />
                        </EditPanelButtons>
                    </validatingElements.ItemUrlForm>
                </PanelBody>
            </EditPanel>
        </Tray>
    );
}
